import i18n from 'helper/i18n';

import { ContentTypePoolRecipeDtoType } from 'types/services/magnolia/dtos/ContentTypePoolRecipeDto';

export const FILTER_ID = 'RECIPE_CALORIES' as const;

export const FILTER_FACTORY = {
	BELOW_300: (item: ContentTypePoolRecipeDtoType) => {
		return parseInt(item.calories, 10) < 300;
	},
	BETWEEN_300_500: (item: ContentTypePoolRecipeDtoType) => {
		return parseInt(item.calories, 10) >= 300 && parseInt(item.calories, 10) <= 500;
	},
	BETWEEN_500_700: (item: ContentTypePoolRecipeDtoType) => {
		return parseInt(item.calories, 10) >= 500 && parseInt(item.calories, 10) <= 700;
	},
	ABOVE_700: (item: ContentTypePoolRecipeDtoType) => {
		return parseInt(item.calories, 10) > 700;
	},
};

export function getFilterValueKeyByCalories(calories: string): string {
	// iterate over each filter function
	const item = { calories };
	const filterValueKey = Object.keys(FILTER_FACTORY).filter((key) => {
		if (FILTER_FACTORY[key](item)) {
			return true;
		}
		return false;
	});

	return filterValueKey[0];
}

export const FILTER = {
	BELOW_300: 'BELOW_300',
	BETWEEN_300_500: 'BETWEEN_300_500',
	BETWEEN_500_700: 'BETWEEN_500_700',
	ABOVE_700: 'ABOVE_700',
} as const;

export const FILTER_LABELS: { [key: string]: React.ReactNode } = {
	BELOW_300: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.BELOW_300}`),
	BETWEEN_300_500: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.BETWEEN_300_500}`),
	BETWEEN_500_700: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.BETWEEN_500_700}`),
	ABOVE_700: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.ABOVE_700}`),
};

export function filterForCalories(filter: (keyof typeof FILTER)[]): (item: ContentTypePoolRecipeDtoType) => boolean {
	return (item: ContentTypePoolRecipeDtoType) => FILTER_FACTORY[filter[0]](item);
}

export default filterForCalories;
